module.exports = __webpack_public_path__ + "static/media/standing-watching-svgrepo-com.1767cac3.svg";